import { ColorPicker } from "antd";
import type React from "react";

type Props = {
  color?: string;
};

export const ColorIndicator: React.FC<Props> = ({ color }: Props) => {
  if (color) {
    return <ColorPicker value={`#${color}`} size="small" disabled={true} />;
  }
  return <ColorPicker value={"rgba(255, 255, 255, 0)"} size="small" disabled={true} />;
};
